import React, { useEffect, useState } from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import Lightbox from 'react-image-lightbox';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import Box from '@mui/material/Box';
import ImageList from '@mui/material/ImageList';
import ImageListItem from '@mui/material/ImageListItem';
import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import Main from 'layouts/Main';
import { Typography } from '@mui/material';
import Container from 'components/Container';
import PreprimarySidebar2026 from '../PreprimarySidebar2026';
import Presidebar2026 from '../Presidebar2026/Presidebar2026';


const MariaMontessoriDay2026= () => {
  const theme = useTheme();
  const [currentImage, setCurrentImage] = useState(0);
  const [viewerIsOpen, setViewerIsOpen] = useState(false);

  const openLightbox = (index) => {
    setCurrentImage(index);
    setViewerIsOpen(true);
  };

  const closeLightbox = () => {
    setCurrentImage(0);
    setViewerIsOpen(false);
  };

  const isMd = useMediaQuery(theme.breakpoints.up('md'), {
    defaultMatches: true,
  });

  const [config, setConfig] = useState({ base_image_url_2026: '' });
  useEffect(() => {
    fetch('/config.json')  // For Gatsby, this will resolve to /config.json from the static folder
      .then(response => response.json())
      .then(data => setConfig(data))
      .catch(error => console.error('Error fetching config:', error));
  }, []);
  
  const p1 = `${config.base_image_url_2026}/home/events-activities/club/EcoClub/MariaDay/1.webp`;
  const p2 = `${config.base_image_url_2026}/home/events-activities/club/EcoClub/MariaDay/2.webp`;
  const p3 = `${config.base_image_url_2026}/home/events-activities/club/EcoClub/MariaDay/3.webp`;
  const p4 = `${config.base_image_url_2026}/home/events-activities/club/EcoClub/MariaDay/4.webp`;
  const p5 = `${config.base_image_url_2026}/home/events-activities/club/EcoClub/MariaDay/5.webp`;
  const p6 = `${config.base_image_url_2026}/home/events-activities/club/EcoClub/MariaDay/6.webp`;
  const p7 = `${config.base_image_url_2026}/home/events-activities/club/EcoClub/MariaDay/7.webp`;
  const p8 = `${config.base_image_url_2026}/home/events-activities/club/EcoClub/MariaDay/8.webp`;


  const photos = [
    {
    src: p1,
    source: p1,
    rows: 1,
    cols: 1,
},
{
    src: p2,
    source: p2,
    rows: 1,
    cols: 1,
},
{
    src: p3,
    source: p3,
    rows: 1,
    cols: 1,
},
{
    src: p4,
    source: p4,
    rows: 1,
    cols: 1,
},
{
    src: p5,
    source: p5,
    rows: 1,
    cols: 1,
},
{
    src: p6,
    source: p6,
    rows: 1,
    cols: 1,
},

{
    src: p7,
    source: p7,
    rows: 1,
    cols: 1,
},
{
    src: p8,
    source: p8,
    rows: 1,
    cols: 1,
},





  ];

  return (
    <Main>
   
<Container>

  <Grid container spacing={4}>
            <Grid item xs={12} md={8}>
    <Box>
        
      <Box >
      <Typography variant='h4' align='center' >
Topic: Maria Montessori Day Celebration
        </Typography>
        <Typography
        fontSize = "x-small"
        ><br/><br/>
    Classes: Montessori – I, II, III	    Date: 31 August, 2026
        </Typography>
        {/* <Typography
          variant={'h6'}
          color={'primary'}
          align={'center'}
          fontWeight={'normal'}
        ><br/>
 Embracing the traditions of Kerala with joy and enthusiasm.
<br></br>
        </Typography> */}


        <Typography variant={'subtitle1'} align={'justify'}>
The students of Montessori, Kindergarten and Class 1 came together on Monday, 31st August 2026, to fondly commemorate the inspiring educator, Dr Maria Montessori, with great enthusiasm and fervour. Our school joyfully celebrated Dr Maria Montessori Day with a captivating presentation by the talented students of Montessori, who paid a heartfelt tribute to Dr Maria Montessori and her vision of nurturing children through creativity, confidence, independence and joyful learning.
      <br></br>
The young performers from Montessori showcased their talents through a thoughtful speech, a melodious song, an engaging skit and a delightful dance performance. Their enthusiastic participation and confident presentations made the occasion truly memorable.
 <br></br>
A special highlight of the celebration was a showcase celebrating great teachers and educators who have enriched India’s educational legacy over the years. The Montessori students came dressed as eminent educators such as Dr Sarvepalli Radhakrishnan, Savitribai Phule, Dr A. P. J. Abdul Kalam, Dr Zakir Husain and several other renowned personalities, bringing their inspiring contributions to life.

<br></br>
Adding another meaningful dimension to the festivities, the students of Montessori presented a demonstration of Montessori materials in the other classes of the Foundational Years. With confidence and enthusiasm, they demonstrated how these carefully designed materials help develop essential skills such as concentration, coordination, fine-motor skills, sensory awareness, logical thinking, independence and problem-solving abilities.

<br></br>
The entire programme beautifully reflected the Montessori philosophy of “learning by doing,” where children are encouraged to explore, discover and learn independently in a joyful and stimulating environment. The wonderful performances, meaningful presentations and confident participation of the children truly captured the essence of Dr Maria Montessori’s vision and made the celebration a memorable tribute to her enduring legacy.
<br></br>
        </Typography>
      </Box>
      <Typography
          variant={'h6'}
          color={'primary'}
          align={'center'}
          fontWeight={'normal'}
        ><br/>
Education cannot be effective unless it helps a child to open up himself to life.
<br/>
        </Typography>

      <Box>
        <ImageList
          variant="quilted"
          cols={2}
          rowHeight={isMd ? 300 : 200}
          gap={isMd ? 16 : 4}
        >
          {photos.map((item, i) => (
            <ImageListItem key={i} cols={item.cols} rows={item.rows}>
              <LazyLoadImage
                height={'100%'}
                width={'100%'}
                src={item.src}
                alt="..."
                effect="blur"
                onClick={() => openLightbox(i)}
                style={{
                  objectFit: 'cover',
                  filter:
                    theme.palette.mode === 'dark' ? 'brightness(0.7)' : 'none',
                  cursor: 'poiner',
                  borderRadius: 8,
                }}
              />
            </ImageListItem>
          ))}
        </ImageList>
      </Box>
      {viewerIsOpen && (
        <Lightbox
          mainSrc={photos[currentImage].src}
          nextSrc={photos[(currentImage + 1) % photos.length].src}
          prevSrc={
            photos[(currentImage + photos.length - 1) % photos.length].src
          }
          onCloseRequest={() => closeLightbox()}
          onMovePrevRequest={() =>
            setCurrentImage((currentImage + photos.length - 1) % photos.length)
          }
          onMoveNextRequest={() =>
            setCurrentImage((currentImage + 1) % photos.length)
          }
          reactModalStyle={{ overlay: { zIndex: 1500 } }}
        />
      )}
    </Box>
    </Grid>

    <Grid item xs={12} md={4}>
             
             <Box marginBottom={4}>
               <PreprimarySidebar2026 />
             </Box>
             <Box marginBottom={4}>
               <Presidebar2026 />
             </Box>


    </Grid>
    </Grid> 
    </Container>
    </Main>
   
   
  );
};

export default MariaMontessoriDay2026;